const TariffsBox = () => {
	const block = document.querySelectorAll(".tariffs-box");
	if (!block) {
		return;
	}

	block.forEach((el) => {
		const header = document.querySelector(".header");
		const stickyControl = document.querySelector(".sticky-mobile-bar");
		const tableHead = el.querySelector(".tariffs-box__table-head");
		const table = el.querySelector(".tariffs-box__table");
		const mobilePlanNavItems = el.querySelectorAll(".tariffs-box__table-title");
		const tableHeadHeight = tableHead.offsetHeight;
		const isMobile = window.innerWidth < 768;

		const resetPlansState = () => {
			el.querySelectorAll(".tariffs-box__col").forEach(item => {
				item.classList.remove("active");
			});
		};

		mobilePlanNavItems.forEach(item => {
			item.addEventListener("click", (e) => {
				const parent = e.target.closest(".tariffs-box__col");
				if (!parent.classList.contains("active")) {
					resetPlansState();

					parent.classList.add("active");
					el.querySelector(`.tariffs-box__col[data-plan="${e.target.getAttribute("data-plan")}"]`).classList.add("active");
				}
			});
		});
		
		if (!isMobile) {
			const panelSticky = new StickySidebar(tableHead, {
				containerSelector: ".tariffs-box__table-body",
				topSpacing: 0,
				bottomSpacing: 400
				// resizeSensor: true
			});
		}

		const showStickyPanel = () => {
			table.classList.add("is-sticky");
			tableHead.style.height = `${tableHeadHeight}px`;
			header.classList.add("is-hidden");

			if (stickyControl) {
				stickyControl.classList.add("is-hidden");
			}
		};

		const hideStickyPanel = () => {
			table.classList.remove("is-sticky");
			tableHead.style.height = null;
			header.classList.remove("is-hidden");

			if (stickyControl) {
				stickyControl.classList.remove("is-hidden");
			}
		};

		tableHead.addEventListener("affixed.top.stickySidebar", showStickyPanel);
		tableHead.addEventListener("affixed.static.stickySidebar", hideStickyPanel);
		tableHead.addEventListener("affixed.container-bottom.stickySidebar", hideStickyPanel);

		// cell hover
		const columns = el.querySelectorAll(".tariffs-box__table-body .tariffs-box__col");
		const allCells = el.querySelectorAll(".tariffs-box__table-body .tariffs-box__cell");

		const setHover = (index) => {
			columns.forEach((col) => {
				col.querySelectorAll(".tariffs-box__cell")[index].classList.add("hover");
			});
		};

		const setUnHover = () => {
			allCells.forEach((item) => {
				item.classList.remove("hover");
			});
		};

		columns.forEach((col) => {
			const cells = col.querySelectorAll(".tariffs-box__cell");

			cells.forEach((cell, index) => {
				cell.addEventListener("mouseover", (e) => {
					setHover(index);
				});
				cell.addEventListener("mouseleave", (e) => {
					setUnHover();
				});
			});
		});

		// change credits select
		el.querySelector(".tariffs-box__table-select_credits").addEventListener("change", (e) => {
			const target = e.target.options[e.target.selectedIndex].value;

			if (creditsPlans) {
				const plan = creditsPlans.filter(item => item.id === target);

				const price = el.querySelector(".tariffs-box [data-credits-price]");
				const discount = el.querySelector(".tariffs-box [data-credits-discount]");
				const minutes = el.querySelector(".tariffs-box [data-credits-minutes]");
				const characters = el.querySelector(".tariffs-box [data-credits-characters]");

				price.textContent = `$${plan[0].price}`;
				discount.textContent = `${plan[0].discount}%`;
				if (parseInt(plan[0].discount) === 0) {
					discount.closest(".tariffs-box__cell").classList.add("inactive");
				} else {
					discount.closest(".tariffs-box__cell").classList.remove("inactive");
				}
				minutes.textContent = plan[0].minutesSts;
				characters.textContent = plan[0].characters;
			}
		});

		// TTS selects
		const choicesOptions = {
			allowHTML: true,
			searchEnabled: false,
			itemSelectText: "",
			shouldSort: false
		};
		const ttsChoicesHead = new Choices(
			el.querySelector(".tariffs-box__table-head .tariffs-box__table-select_tts"),
			choicesOptions
		);
		const ttsChoicesBody = new Choices(
			el.querySelector(".tariffs-box__table-body .tariffs-box__table-select_tts"),
			choicesOptions
		);

		el.querySelectorAll(".tariffs-box__table-select_tts").forEach((select, index) => {
			select.addEventListener("change", (e) => {
				const target = e.target.options[e.target.selectedIndex].value;

				ttsChoicesHead.setChoiceByValue(target);
				ttsChoicesBody.setChoiceByValue(target);

				if (ttsPlans) {
					const plan = ttsPlans.filter(item => item.id === target);

					const price = el.querySelector(".tariffs-box [data-tts-price]");
					const discount = el.querySelector(".tariffs-box [data-tts-discount]");

					price.textContent = plan[0].price;
					discount.textContent = plan[0].discount;
				}
			});
		});

		const setNavSelectMobile = () => {
			if (window.innerWidth < 768) {
				mobilePlanNavItems.forEach(item => {
					const parent = item.closest(".tariffs-box__col");
					const plan = item.getAttribute("data-plan");
					const navSelect = parent.querySelector(".tariffs-box__table-select-wrap");

					if (navSelect) {
						el.querySelector(`.tariffs-box__col[data-plan="${plan}"]`).prepend(navSelect);
					}
				});
			} else {
				el.querySelectorAll(".tariffs-box__table-body .tariffs-box__col").forEach(item => {
					const plan = item.getAttribute("data-plan");
					const select = item.querySelector(".tariffs-box__table-select-wrap");
					const navItem = el.querySelector(`.tariffs-box__table-title[data-plan="${plan}"]`);

					if (select) {
						navItem.closest(".tariffs-box__cell").append(select);
					}
				});
			}
		};
		setNavSelectMobile();
		window.addEventListener("resize", (e) => {
			setNavSelectMobile();
		});
	});
};

export default TariffsBox;
